import React from "react";
import { TextField } from "@mui/material";
import { Filter, InputChange } from "./datafilter-types";

interface UppercaseStringFilterProps {
  filter: Filter;
  onChangeString: (name: string, value: InputChange) => void;
}

const UppercaseStringFilter: (
  props: UppercaseStringFilterProps
) => JSX.Element = ({ filter, onChangeString }) => {
  const { name, placeholder, value } = filter;
  return (
    <TextField
      aria-label={placeholder}
      inputProps={{
        "data-testid": `${name}-input`,
      }}
      onChange={(ev) => {
        onChangeString(
          name,
          Object.assign(ev, {
            target: { value: ev.target.value.toUpperCase() },
          })
        );
      }}
      label={placeholder}
      value={value?.toUpperCase() || ""}
    />
  );
};

export default UppercaseStringFilter;
